export const ALLOWED_REQUEST_URL = [
    'accounts',
    'address-book',
    'vehicles',
    'ruc-vehicles',
    'mro-smartcar',
    'mro-manual',
    'payment',
    'tolling',
    'promo-wallet',
    'activities',
    'invoices',
];
